var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Node } from '../Node';
var Group = /** @class */ (function (_super) {
    __extends(Group, _super);
    function Group(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, 'group', options) || this;
        _this.children = [];
        /** When true, subtree is cached to offscreen bitmap when static. */
        _this.cacheAsBitmap = false;
        if (options.cacheAsBitmap)
            _this.cacheAsBitmap = true;
        return _this;
    }
    Group.prototype.add = function () {
        var e_1, _a;
        var nodes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
        }
        try {
            for (var nodes_1 = __values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
                var node = nodes_1_1.value;
                if (node.parent && 'remove' in node.parent) {
                    node.parent.remove(node);
                }
                node.parent = this;
                this.children.push(node);
                this.sortChildren();
                node.markDirty();
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.markDirty();
        return this;
    };
    Group.prototype.remove = function (node) {
        var idx = this.children.indexOf(node);
        if (idx >= 0) {
            this.children.splice(idx, 1);
            node.parent = null;
            this.markDirty();
        }
        return this;
    };
    Group.prototype.clear = function () {
        var e_2, _a;
        try {
            for (var _b = __values(this.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                child.parent = null;
                child.destroy();
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        this.children = [];
        this.markDirty();
        return this;
    };
    Group.prototype.getChildById = function (id) {
        var e_3, _a;
        try {
            for (var _b = __values(this.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                if (child.id === id)
                    return child;
                if (child instanceof Group) {
                    var found = child.getChildById(id);
                    if (found)
                        return found;
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return undefined;
    };
    Group.prototype.sortChildren = function () {
        this.children.sort(function (a, b) { return a.zIndex - b.zIndex; });
    };
    Group.prototype.containsPoint = function (_localX, _localY) {
        for (var i = this.children.length - 1; i >= 0; i--) {
            var child = this.children[i];
            if (!child.visible || !child.listening)
                continue;
            var wm = child.getWorldMatrix();
            var inv = wm.invert();
            if (!inv)
                continue;
            var local = inv.transformPoint(_localX + this.x, _localY + this.y);
            if (child.containsPoint(local.x - child.x, local.y - child.y))
                return true;
        }
        return false;
    };
    Group.prototype.getBounds = function () {
        var e_4, _a, e_5, _b;
        if (this.children.length === 0) {
            return { x: 0, y: 0, width: 0, height: 0 };
        }
        var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        try {
            for (var _c = __values(this.children), _d = _c.next(); !_d.done; _d = _c.next()) {
                var child = _d.value;
                var b = child.getBounds();
                var wm = child.getWorldMatrix();
                var corners = [
                    wm.transformPoint(b.x, b.y),
                    wm.transformPoint(b.x + b.width, b.y),
                    wm.transformPoint(b.x, b.y + b.height),
                    wm.transformPoint(b.x + b.width, b.y + b.height),
                ];
                try {
                    for (var corners_1 = (e_5 = void 0, __values(corners)), corners_1_1 = corners_1.next(); !corners_1_1.done; corners_1_1 = corners_1.next()) {
                        var c = corners_1_1.value;
                        minX = Math.min(minX, c.x);
                        minY = Math.min(minY, c.y);
                        maxX = Math.max(maxX, c.x);
                        maxY = Math.max(maxY, c.y);
                    }
                }
                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                finally {
                    try {
                        if (corners_1_1 && !corners_1_1.done && (_b = corners_1.return)) _b.call(corners_1);
                    }
                    finally { if (e_5) throw e_5.error; }
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return { x: minX, y: minY, width: maxX - minX, height: maxY - minY };
    };
    Group.prototype.draw = function (ctx) {
        var _a;
        var renderer = ctx;
        (_a = renderer.drawGroup) === null || _a === void 0 ? void 0 : _a.call(renderer, this);
    };
    Group.prototype.toJSON = function () {
        return __assign(__assign({}, _super.prototype.toJSON.call(this)), { children: this.children.map(function (c) { return c.toJSON(); }) });
    };
    return Group;
}(Node));
export { Group };
var Layer = /** @class */ (function (_super) {
    __extends(Layer, _super);
    function Layer(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, options) || this;
        _this.type = 'layer';
        return _this;
    }
    return Layer;
}(Group));
export { Layer };
